module.exports = __webpack_public_path__ + "img/play1-icon.0036bbc4.svg";